import { Format } from 'admin-columns-js/helper/strings';
var i18n = {
    SELECTED: ACP_Editing.i18n.bulk_edit.selecting.selected,
    SELECTALL: ACP_Editing.i18n.bulk_edit.selecting.select_all
};
var SELECTORS = {
    ROW: 'acp-be-noticerow'
};
var BulkNotice = /** @class */ (function () {
    function BulkNotice(Table) {
        this.notice = null;
        this.Table = Table;
    }
    BulkNotice.prototype.addNotice = function () {
        var _this = this;
        this.createNotice();
        this.createNoticeRow();
        this.refreshNoticeRow();
        document.querySelectorAll('.hide-column-tog').forEach(function (cb) {
            cb.addEventListener('click', function () {
                _this.refreshNoticeRow();
            });
        });
    };
    BulkNotice.prototype.removeNotice = function () {
        var notice = this.Table.el.querySelector("." + SELECTORS.ROW);
        if (notice) {
            notice.remove();
        }
    };
    BulkNotice.prototype.createNotice = function () {
        var notice = document.createElement('div');
        notice.classList.add('acp-be-notice');
        var p = document.createElement('p');
        var text = Format(i18n.SELECTED + " ", "<span data-acp-be-count></span>");
        p.insertAdjacentHTML('beforeEnd', text);
        notice.append(p);
        this.notice = notice;
    };
    BulkNotice.prototype.createSelectAll = function (number) {
        if (document.querySelector('.ac-be-selectall')) {
            return document.querySelector('.ac-be-selectall');
        }
        if (number === false || number === 'all') {
            number = '';
        }
        if (!this.notice) {
            return;
        }
        var link = document.createElement('a');
        link.innerHTML = Format(i18n.SELECTALL, number);
        link.classList.add('ac-be-selectall');
        this.notice.querySelector('p').append(link);
        return link;
    };
    BulkNotice.prototype.createNoticeRow = function () {
        var row = document.createElement('tr');
        var col = document.createElement('td');
        row.append(col);
        row.classList.add(SELECTORS.ROW);
        var colspan = AdminColumns.Table.el.querySelector('thead tr').children.length;
        col.setAttribute('colspan', colspan);
        col.append(this.notice);
        this.Table.el.querySelector('tbody').insertAdjacentElement('afterBegin', row);
        return row;
    };
    BulkNotice.prototype.refreshNoticeRow = function () {
        var cells = this.Table.el.firstElementChild.firstElementChild.querySelectorAll('td,th');
        var colspan = 0;
        cells.forEach(function (cell) {
            if (!cell.classList.contains('hidden')) {
                colspan++;
            }
        });
        this.Table.el.querySelector("." + SELECTORS.ROW + " td").setAttribute('colspan', colspan);
    };
    return BulkNotice;
}());
export default BulkNotice;
